import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useApiServices } from '../../services/api-endpoints/useApiServices';

const ImageViewer = React.memo(
    ({ id, preview = true, download = false, width = 140, alt = 'image', className = '' }) => {
        const [imageSrc, setImageSrc] = useState(null);
        const [error, setError] = useState(false);
        const [show, setShow] = useState(false);
        const api = useApiServices();

        useEffect(() => {
            if (!id) return;
            let isMounted = true;
            let objectUrl = null;

            const fetchImage = async () => {
                try {
                    const blob = await api.GetFileContentAsync(id);
                    if (!blob || blob.isSuccess === false || !(blob instanceof Blob)) {
                        if (isMounted) setError(true);
                        return;
                    }
                    objectUrl = URL.createObjectURL(blob);
                    if (isMounted) setImageSrc(objectUrl);
                } catch {
                    if (isMounted) setError(true);
                }
            };

            fetchImage();
            return () => {
                isMounted = false;
                if (objectUrl) URL.revokeObjectURL(objectUrl);
            };
        }, [id]);

        if (!id) return <span style={{ color: '#9ca3af', fontSize: 13 }}>-</span>;

        if (error) return (
            <div style={{
                width, height: width, borderRadius: 10,
                background: '#f3f4f6', border: '1px solid #e5e7eb',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                color: '#9ca3af', fontSize: 11,
            }}>
                <i className="fa fa-image" style={{ fontSize: 20, marginBottom: 4, opacity: 0.4 }} />
                โหลดไม่ได้
            </div>
        );

        if (!imageSrc) return (
            <div style={{
                width, height: width, borderRadius: 10,
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 1.4s infinite',
            }}>
                <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
            </div>
        );

        return (
            <>
                <div
                    onClick={() => preview && setShow(true)}
                    style={{
                        position: 'relative', display: 'inline-block',
                        borderRadius: 10, overflow: 'hidden',
                        border: '1px solid #e5e7eb',
                        cursor: preview ? 'pointer' : 'default',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        transition: 'all 0.15s',
                    }}
                    onMouseEnter={e => { if (preview) e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.14)'; }}
                    onMouseLeave={e => { if (preview) e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)'; }}
                >
                    <img
                        src={imageSrc}
                        alt={alt}
                        className={className}
                        style={{ width, height: width, objectFit: 'cover', display: 'block' }}
                    />
                    {preview && (
                        <div style={{
                            position: 'absolute', inset: 0, background: 'rgba(0,0,0,0)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            transition: 'background 0.15s',
                        }}
                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.28)'}
                            onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0)'}
                        >
                            <i className="fa fa-search-plus" style={{ color: '#fff', fontSize: 18, opacity: 0, transition: 'opacity 0.15s', pointerEvents: 'none' }} />
                        </div>
                    )}
                </div>

                <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
                    <Modal.Header closeButton style={{ borderBottom: '1px solid #f3f4f6' }}>
                        <Modal.Title style={{ fontSize: 15, fontWeight: 700 }}>ดูรูปภาพ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ textAlign: 'center', background: '#0f172a', padding: 16 }}>
                        {imageSrc && (
                            <img
                                src={imageSrc}
                                alt={alt}
                                style={{ maxWidth: '100%', maxHeight: '72vh', objectFit: 'contain', borderRadius: 8 }}
                            />
                        )}
                    </Modal.Body>
                    {download && (
                        <Modal.Footer style={{ borderTop: '1px solid #f3f4f6', justifyContent: 'center' }}>
                            <a
                                href={imageSrc}
                                download={`image-${id}`}
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 7,
                                    padding: '7px 18px', background: 'linear-gradient(135deg, #1e3a5f, #2d6a9f)',
                                    color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 600,
                                    textDecoration: 'none',
                                }}
                            >
                                <i className="fa fa-download" />ดาวน์โหลด
                            </a>
                        </Modal.Footer>
                    )}
                </Modal>
            </>
        );
    }
);

export default ImageViewer;
